import * as React from 'react';
import DetailsCard from '../common/DetailsCard';
import { FormattedCurrency } from '../common/FormattedCurrency';
import strings from './strings';
import './style/index.scss';
export class MarketSnapshotCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this._percentiles = [
            strings.percentile25th,
            strings.percentile50th,
            strings.percentile75th
        ];
    }
    static isValidData(marketBaseSalary25th, marketBaseSalary50th, marketBaseSalary75th, marketTotalCash25th, marketTotalCash50th, marketTotalCash75th) {
        const hasSalary = MarketSnapshotCard._hasValidValues([
            marketBaseSalary25th,
            marketBaseSalary50th,
            marketBaseSalary75th
        ]);
        const hasTotalCash = MarketSnapshotCard._hasValidValues([
            marketTotalCash25th,
            marketTotalCash50th,
            marketTotalCash75th
        ]);
        return hasSalary && hasTotalCash;
    }
    render() {
        const { currency, marketBaseSalary25th, marketBaseSalary50th, marketBaseSalary75th, marketTotalCash25th, marketTotalCash50th, marketTotalCash75th, currencyFormatter } = this.props;
        if (!MarketSnapshotCard.isValidData(marketBaseSalary25th, marketBaseSalary50th, marketBaseSalary75th, marketTotalCash25th, marketTotalCash50th, marketTotalCash75th)) {
            return null;
        }
        const totalCashComp = [marketTotalCash25th, marketTotalCash50th, marketTotalCash75th];
        const basePay = [marketBaseSalary25th, marketBaseSalary50th, marketBaseSalary75th];
        return (React.createElement(DetailsCard, { className: "market-snapshot-card", title: strings.cardTitle },
            this._renderTable(totalCashComp, basePay, currency, currencyFormatter),
            React.createElement("div", { className: "market-snapshot-card__description" },
                React.createElement("span", { className: "market-snapshot-card__description--width" }, strings.description))));
    }
    static _hasValidValues(values) {
        return values.reduce((acc, val) => acc || val == null, false) === false;
    }
    _renderTable(totalCashComp, basePay, currency, currencyFormatter) {
        const formatOptions = {
            fractionalDigits: 0
        };
        return (React.createElement("div", { className: "market-snapshot-card" },
            React.createElement("table", { className: "market-snapshot-card__table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, strings.tccHeader),
                        React.createElement("th", null, strings.basePayHeader))),
                React.createElement("tbody", null, this._percentiles.map((percentile, i) => React.createElement("tr", { className: "market-snapshot-card__table-row", key: percentile },
                    React.createElement("td", { className: "percentile" }, percentile),
                    React.createElement("td", { className: "tcc" },
                        React.createElement(FormattedCurrency, { val: totalCashComp[i], currency: currency, formatFunc: currencyFormatter, options: formatOptions })),
                    React.createElement("td", { className: "base-pay" },
                        React.createElement(FormattedCurrency, { val: basePay[i], currency: currency, formatFunc: currencyFormatter, options: formatOptions }))))))));
    }
}
export default MarketSnapshotCard;
